import { render, staticRenderFns } from "./FixArea.vue?vue&type=template&id=2ca4d7ed&"
import script from "./FixArea.vue?vue&type=script&lang=ts&"
export * from "./FixArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports